import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Button } from '@aws-amplify/ui-react';
import dayjs from 'dayjs';
import { useSetRecoilState } from 'recoil';
import { Theme, useMediaQuery } from '@mui/material';

import { SectionDialogState } from '../../../atom/DialogState';

/* 1セルの高さ定義 */
const itemHeight = 60;

const ScheduleTimeData = ({ availabilityList, date }: { availabilityList: any; date: string }) => {
  // TODO:開始時刻、終了時刻で計算する
  let height = 0;

  const setSectionDialogState = useSetRecoilState(SectionDialogState);
  const navigate = useNavigate();
  /* サイズチェック */
  const isMobileSize = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const [searchParams] = useSearchParams();
  const areaId = searchParams.get('areaId') ?? '';
  const facilityId = searchParams.get('facilityId') ?? '';
  const title = searchParams.get('title') ?? '';

  // TODO 施設ごとに可変対応
  // 30分単位で帰ってくるため一つ飛ばしで配列化
  const filteredAvailabilityList = [];
  for (let i = 0; i < availabilityList.length; i += 2) {
    filteredAvailabilityList.push(availabilityList[i]);
  }


  return (
    <>
      {filteredAvailabilityList.map((usage: any, index: any) => {
        const start = dayjs(`1970-01-01T${usage.reservedStartTime}`);
        const end = dayjs(`1970-01-01T${usage.reservedEndTime}`);
        const diff = end.diff(start, 'minute');
        const slot = diff / 30;

        // TODO 施設ごとに可変対応
        const thisHeight = (usage.reservationFlag === '3' || usage.reservationFlag === '2'|| usage.reservationFlag === '5')
        ? itemHeight * slot / 2
        : itemHeight * slot;

        // タイトル部分
        const top = isMobileSize ? 272 + height : 278 + height;

        let style = {};
        let text = '';

        // 予約区分に応じてスタイルを変更する。デフォルトは空き
        switch (usage.reservationFlag) {
          case '1': // 空きなし
            style = { background: '#EEF1F4', color: 'grey', fontSize: '20px', padding: '5px' };
            text = '×';
            break;
          case '2': // 休館日
            style = {
              background: '#EEF1F4',
              color: 'grey',
              fontSize: '35px',
              writingMode: 'vertical-rl',
              textOrientation: 'upright',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center'
            };
            text = '休館日';
            break;
          case '3': // 受付開始前
            style = {
              background: '#EEF1F4',
              color: 'grey',
              fontSize: '35px',
              writingMode: 'vertical-rl',
              textOrientation: 'upright',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center'
            };
            text = '受付開始前';
            break;
          case '5': // 受付開始前
            style = {
              background: '#EEF1F4',
              color: 'grey',
              fontSize: '35px',
              writingMode: 'vertical-rl',
              textOrientation: 'upright',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center'
            };
            text = '受付終了';
            break;
          default: // 空いている状態
            style = {
              background: 'transparent',
              color: '#02ADA9',
              fontSize: '30px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              border: 'none'
            };
            text = '○';
            break;
        }
        height += thisHeight;

        return (
          <Button
            key={`${facilityId}${areaId}${usage.reservedStartTime}`}
            disabled={text !== '○'}
            style={{
              height: `${thisHeight}px`,
              width: isMobileSize ? 'calc(100% / 8.8)' : 'calc(100% / 8.5)',
              top: `${top}px`,
              position: 'absolute',
              border: 'none',
              ...style
            }}
            onClick={() =>
              navigate(`/c006/sectionschedule/?facilityId=${facilityId}&areaId=${areaId}&date=${date}&title=${title}`)
            }
          >
            <div>{text}</div>
          </Button>
        );
      })}
    </>
  );
};

export default ScheduleTimeData;
